import * as React from 'react';
import {
  AppLocalizationKey,
  CarouselBreakpoints,
  ExamplesItem as TExamplesItem,
} from '~/common/types/types';
import { Carousel } from '~/components/common/common';
import { ExamplesItem } from '../components';
import * as styles from './examples-list.module.scss';

const BREAKPOINTS: CarouselBreakpoints = {
  0: {
    slidesPerView: 'auto',
    spaceBetween: '15',
    wrapperClassName: styles.wrapper,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: '20',
    wrapperClassName: styles.wrapper,
  },
  992: {
    slidesPerView: 1,
    spaceBetween: '70',
    wrapperClassName: styles.wrapper,
  },
};

type Props = {
  items: TExamplesItem[];
  techListTitle: AppLocalizationKey;
};

const ExamplesList: React.FC<Props> = ({ items, techListTitle }) => (
  <div className={styles.carouselWrapper}>
    <Carousel
      breakpoints={BREAKPOINTS}
      hasPagination
      hasNavigation
      className={styles.carousel}
    >
      {items.map((it) => (
        <ExamplesItem item={it} key={it.title} techListTitle={techListTitle} />
      ))}
    </Carousel>
  </div>
);

export { ExamplesList };
